import { createContext, PropsWithChildren, useContext } from 'react';
import { UploadedFile } from '../core/types';
import { useManualUpload } from './useManualUpload';

const MUContext = createContext<{
  onSubmitMU: React.FormEventHandler<HTMLFormElement>;
  onSelectFilesMU: (files: File[] | null) => void;
  onDeleteFileMU: (name: string) => () => void;
  filesToUploadMU: File[];
  isLoadingMU: boolean;
  isUploadingMU: boolean;
  uploadedFilesMU: UploadedFile[];
}>({
  onSubmitMU: () => {},
  onSelectFilesMU: () => {},
  onDeleteFileMU: () => () => {},
  filesToUploadMU: [],
  uploadedFilesMU: [],
  isLoadingMU: false,
  isUploadingMU: false,
});

export function MUProvider({ children }: PropsWithChildren<{}>) {
  const {
    filesToUpload: filesToUploadMU,
    onSubmit: onSubmitMU,
    onSelectFiles: onSelectFilesMU,
    onDeleteFile: onDeleteFileMU,
    isLoading: isLoadingMU,
    isUploading: isUploadingMU,
    uploadedFiles: uploadedFilesMU,
  } = useManualUpload();

  return (
    <MUContext.Provider
      value={{
        onSubmitMU,
        onSelectFilesMU,
        onDeleteFileMU,
        filesToUploadMU,
        isLoadingMU,
        isUploadingMU,
        uploadedFilesMU,
      }}
    >
      {children}
    </MUContext.Provider>
  );
}

export const useMU = () => {
  return useContext(MUContext);
};
